module.exports = __webpack_public_path__ + "img/Res_Mus_bkl.f6b13c9e.jpg";